import { NgClass, NgStyle } from '@angular/common'
import { Component, input, EventEmitter, Output } from '@angular/core'
import { ServerRepresentedEvent } from '@app/modules/events/models/event.model'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-event-card',
  imports: [NgStyle, NgClass],
  templateUrl: './event-card.component.html',
  styleUrl: './event-card.component.scss'
})
export class EventCardComponent {
  public event = input<ServerRepresentedEvent>()

  @Output() eventSelected = new EventEmitter<ServerRepresentedEvent>()

  constructor(private _translate: TranslateService) {}

  /**
   * @description Gets cover-page photo for event card header
   * @returns string
   */
  get getCoverPhoto(): string {
    return this.event()?.cover_page ? `url(${this.event()?.cover_page})` : `url(https://library.micetribe.com/icons/default_cover.svg)`
  }

  /**
   * @description Gets the event status based on start and end dates
   * @returns string
   */
  get eventStatus(): string {
    const event = this.event()
    if (!event?.public_start_date || !event?.public_end_date) return 'Unknown'

    const now = new Date()
    const startDate = new Date(event.public_start_date)
    const endDate = new Date(event.public_end_date)

    if (now < startDate) return this._translate.instant('v2.orgSettings.micetribeAdmin.upcoming') || 'Upcoming'
    else if (now >= startDate && now <= endDate) return this._translate.instant('v2.orgSettings.micetribeAdmin.live') || 'Live'
  }

  /**
   * Gets the raw event status (English) for template conditions
   * @returns string
   */
  get eventStatusRaw(): string {
    const event = this.event()
    if (!event?.public_start_date || !event?.public_end_date) return 'Unknown'

    const now = new Date()
    const startDate = new Date(event.public_start_date)
    const endDate = new Date(event.public_end_date)

    if (now < startDate) return 'Upcoming'
    else if (now >= startDate && now <= endDate) return 'Live'
    else return 'Finished'
  }

  /**
   * @description Formats date for display (keeping for potential future use)
   * @param date string
   * @returns string
   */
  formatDate(date: string): string {
    if (!date) return ''

    try {
      const dateObj = new Date(date)
      return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    } catch (error) {
      return date
    }
  }
}
